import { AxiosResponse } from 'axios';
import apiBack from './api';
import { ProcessType } from '../types/Process.d';

export class ProcessTypeService {
  static async getTypeProcessByName(typeNameValue: string): Promise<AxiosResponse> {
    const response = await apiBack.get(`/type-processes/findByName/${typeNameValue}`, {
      validateStatus: status => [200].includes(status),
    });
    return response;
  }

  static async deleteParameterById(paramId: number): Promise<AxiosResponse> {
    const response = await apiBack.delete(`/parameters/${paramId}`);
    return response;
  }

  static async getTypeProcesses(): Promise<AxiosResponse> {
    const response = await apiBack.get('/type-processes', {
      validateStatus: status => [200, 404].includes(status),
    });
    return response;
  }

  static async postTypeProcess(typeProcess: ProcessType): Promise<AxiosResponse> {
    const response = await apiBack.post('/type-processes', typeProcess, {
      validateStatus: (status: number) => [201].includes(status),
    });
    return response;
  }

  static async putTypeProcess(typeProcess: ProcessType): Promise<AxiosResponse> {
    const response = await apiBack.put(`/type-processes/${typeProcess.id}`, typeProcess, {
      validateStatus: (status: number) => [200].includes(status),
    });
    return response;
  }
}
